<template lang="pug">
  b-container(fluid)
    b-table.card-table.scrollable-area.max-h-250.mb-0(:items="cards", :fields="fields", responsive, show-empty)
      template(v-slot:empty)
        p.text-help.mb-0 No tienes tarjetas registradas
      template(v-slot:cell(index)="{ index }")
        p.mb-0.text-help {{ index + 1 }}
      template(v-slot:cell(is_primary)="{ item }")
        p.mb-0 {{ item.is_primary ? 'Sí' : 'No' }}
</template>

<script>
import { createNamespacedHelpers, mapActions } from 'vuex'
const accountController = createNamespacedHelpers('account')

export default {
  data () {
    return {
      fields: [
        {
          key: 'index',
          label: '#'
        },
        {
          key: 'name',
          label: 'Nombre'
        },
        {
          key: 'last_digits',
          label: 'Últimos digitos'
        },
        {
          key: 'issuer',
          label: 'Tipo'
        },
        {
          key: 'is_primary',
          label: 'Principal'
        }
      ],
    }
  },
  computed: {
    ...accountController.mapState({
      cards: state => state.cards
    }),
  },
  methods: {
    ...mapActions(['account/cards', 'card/destroy']),
    getCards() {
      let self = this

      this['account/cards']({
        account_id: self.$route.params.account_id,
        callback: res => {
          if (res.error) {
            self.$message.error(res.error)
          }
        }
      })
    },
  },
  mounted () {
    this.getCards()
  }
}
</script>

<style lang="scss" scoped>
</style>
